import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { CheckSquare, Square, Download, Trash2, Info, FileSliders } from "lucide-react";
import DocumentInformation from '../../../modals/DocumentInformation';

const DocumentListing = ({ id, thumbnail, isChecked, onSelect, onDownload, onDelete, name, selectable = true }) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const navigate = useNavigate();

    return (
        <React.Fragment>
            <li className="flex items-center p-3 bg-white border border-slate-200 rounded-lg hover:bg-slate-50/70 transition-colors duration-200">
                {selectable && (
                    <button className="p-2 rounded-md text-slate-400 hover:text-blue-500 hover:bg-blue-100 transition-colors" onClick={() => onSelect(id)}>
                        {isChecked ? <CheckSquare size={20} /> : <Square size={20} />}
                    </button>
                )}
                <img
                    className="w-16 h-16 object-cover rounded-md mx-4 border border-slate-200"
                    src={thumbnail}
                    alt={`${name} thumbnail`}
                />
                <div className="flex-grow">
                    <p className="font-semibold text-slate-700 break-all">
                        {name}
                    </p>
                    <div className="flex space-x-1 mt-2">
                        <button
                            className="p-2 rounded-md text-slate-500 hover:text-blue-600 hover:bg-blue-100 transition-colors"
                            onClick={() => onDownload(id)}
                            title="Download Data"
                        >
                            <Download size={18} />
                        </button>
                        <button
                            className="p-2 rounded-md text-slate-500 hover:text-red-600 hover:bg-red-100 transition-colors"
                            onClick={() => onDelete(id)}
                            title="Delete Document"
                        >
                            <Trash2 size={18} />
                        </button>
                        <button
                            className="p-2 rounded-md text-slate-500 hover:text-slate-700 hover:bg-slate-200 transition-colors"
                            onClick={() => setIsModalOpen(true)}
                            title="Information"
                        >
                            <Info size={18} />
                        </button>
                    </div>
                </div>
                <button
                    className="ml-4 p-3 rounded-lg text-slate-500 bg-slate-100 hover:bg-blue-500 hover:text-white transition-colors"
                    onClick={() => navigate(`/view/${id}`)}
                    title="View Document"
                >
                    <FileSliders size={24} />
                </button>
            </li>
            <DocumentInformation
                name={name}
                isOpen={isModalOpen}
                setIsOpen={setIsModalOpen}
            />
        </React.Fragment>
    );
};

export default DocumentListing;